import { CALL_API } from 'middleware/api';
import * as types from './types/socialMedia';
export const SOCIAL_MEDIA_TYPES = ['TWITTER', 'INSTAGRAM'];
const SOCIAL_MEDIA_DATA_ENDPOINT_PREFIX = {
    TWITTER: '/twitter-data',
    INSTAGRAM: '/instagram-data',
};
export const getSocialMediaData = (type, handle) => ({
    [CALL_API]: {
        endpoint: `${SOCIAL_MEDIA_DATA_ENDPOINT_PREFIX[type]}/${handle}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.GET_SOCIAL_MEDIA_DATA_REQUEST,
            types.GET_SOCIAL_MEDIA_DATA_SUCCESS,
            types.GET_SOCIAL_MEDIA_DATA_FAILURE,
        ],
    },
});
